module.exports = __webpack_public_path__ + "img/VetoSansCond-Medium_1.a4e25c9d.svg";